import { Alert, Box, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { CAPACITY_LABELS } from '@hv/shared';
import { useAdvancement } from '../api/hooks';
import { DecisionPill, FollowUpPill, ScoreBar } from '../components/badges';
import { describeError } from '../components/Notify';
import { useCycleParam, useUrlState } from '../urlState';
import { applicantsText } from './PipelinePage';

export function AdvancementPage() {
  const rows = useAdvancement(useCycleParam());
  const { set } = useUrlState();
  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" alignItems="baseline" justifyContent="space-between" mb={2}>
        <Typography variant="h2">Advancement — Development Pipeline</Typography>
        <Typography variant="body2" color="text.secondary">
          {rows.data ? `${rows.data.length} households · sorted by capacity, then HV score` : ''}
        </Typography>
      </Stack>
      {rows.error && <Alert severity="error">Could not load advancement view: {describeError(rows.error)}</Alert>}
      <TableContainer component={Paper}>
        <Table size="small" aria-label="Advancement pipeline">
          <TableHead>
            <TableRow>
              <TableCell>Family</TableCell>
              <TableCell>Estimated capacity</TableCell>
              <TableCell>HV score</TableCell>
              <TableCell>Owner / last contact</TableCell>
              <TableCell>Next follow-up</TableCell>
              <TableCell>Decision</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.data?.map((h) => (
              <TableRow
                key={h.id}
                hover
                tabIndex={0}
                sx={{ cursor: 'pointer' }}
                onClick={() => set({ h: h.id }, false)}
                onKeyDown={(e) => e.key === 'Enter' && set({ h: h.id }, false)}
              >
                <TableCell>
                  <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{h.familyLastName}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {applicantsText(h)}
                  </Typography>
                </TableCell>
                <TableCell>{CAPACITY_LABELS[h.capacityBand]}</TableCell>
                <TableCell>
                  <ScoreBar score={h.effectiveScore} band={h.band} overridden={h.overridden} status={h.assessmentStatus} aiScore={h.aiScore} />
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{h.ownerName ?? 'Unassigned'}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {h.lastContactAt ? `Last contact ${h.lastContactAt.slice(0, 10)}` : 'No contact logged'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <FollowUpPill date={h.nextFollowUpAt} />
                </TableCell>
                <TableCell>
                  <Stack gap={0.5}>
                    {h.decisions.map((d) => (
                      <DecisionPill key={d} decision={d} />
                    ))}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {rows.data?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6}>No households in this cycle.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
